module.exports = __webpack_public_path__ + "img/chinesecompany169.e060b679.png";